// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__1J1EQ","tab":"Tabs_tab__3C0Ea","tabActive":"Tabs_tabActive__22mqs"};